import { useQuery } from '@tanstack/react-query';
import { getTicketsWaitingForInvoicing } from '../requests/invoicing.request';
import { TicketsWaitingForInvoicingResponse } from '../types/invoicing.types';

export const useTicketsWaitingForInvoicingQuery = () => {
  return useQuery<TicketsWaitingForInvoicingResponse>({
    queryKey: ['tickets-waiting-for-invoicing'],
    queryFn: getTicketsWaitingForInvoicing
  });
};
